let $ = jQuery.noConflict(),
	devMode,
	body,
	mobileCheck = false,
	currentY,
	scrollBar,
	pageTransition,
	barbaInitialized,
	resizeCallbacks = [],
	mobileResizeCallbacks = [],
	barbaCallbacks = [],
	mouseAnimation,
	fullGallery,
	hasTouch = 'ontouchstart' in window;

$(function () {
	initStarterKit();

	// Composants Mobile & Desktop
	mouseAnimation = new Mouse();
	new AnimationTitle();
	fullGallery = new FullGallery();
	new HideShowHeaderLogo();
	new HorizontalDraggable();
	new ImageLoading();
	new ImageReveal();
	new ScrollingImage();
	new ViewportHalfScrolled();

	if (mobileCheck.isMobile) {
		// Composants Mobile uniquement
	} else {
		// Composants Desktop uniquement
	}
});

function initStarterKit() {
	body = $('body');
	mcubeDebug();
	mobileCheck = new MobileCheck();
	new ResizeEvents();
	new SmoothScroll();
	// barbaInitialized = new InitBarba(); // Décommenter pour activer barba JS
	pageTransition = new CustomPageTransition();
	new BasePageTransition();
	new AppearOnScroll();
	new DataLink();
	new Forms();
	new GDPR();
	new InitMatchHeight();
	new MadeByMcube();
}

function scrollListener(newY) {

}
